import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import ProductsTab from "./ProductsTab";
import OrdersTab from "./OrdersTab";
import SettingsTab from "./SettingsTab";
import MessagesTab from "./MessagesTab";

const TABS = [["products", "Products"], ["orders", "Orders"], ["settings", "Site content"], ["messages", "Messages"]];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setAdmin(r.data)).catch(() => { localStorage.removeItem("mm_admin_token"); navigate("/admin/login"); });
  }, [navigate]);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); localStorage.removeItem("mm_admin_token"); navigate("/admin/login"); };
  if (!admin) return <div className="min-h-screen flex items-center justify-center"><Logo className="h-14 animate-pulse" /></div>;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen">
      <header className="flex items-center justify-between px-5 sm:px-10 h-20 border-b border-[var(--mm-line)]">
        <Link to="/" data-testid="admin-view-site-link"><Logo className="h-10" /></Link>
        <div className="flex items-center gap-6 text-xs">
          <span className="hidden sm:inline text-[var(--mm-muted)]">{admin.email}</span>
          <Link to="/" className="nav-link">View site</Link>
          <button data-testid="admin-logout-button" onClick={logout} className="nav-link text-[var(--mm-red)]">Log out</button>
        </div>
      </header>
      <div className="px-5 sm:px-10 py-10">
        <h1 className="font-serif-mm text-5xl mb-8">Atelier <em className="text-[var(--mm-red)]">dashboard</em></h1>
        <Tabs defaultValue="products">
          <TabsList className="bg-transparent p-0 h-auto gap-2 flex-wrap justify-start border-b border-[var(--mm-line)] w-full rounded-none mb-8">
            {TABS.map(([v, l]) => (
              <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="eyebrow rounded-none px-4 py-3 data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-[var(--mm-red)] data-[state=active]:border-b-2 data-[state=active]:border-[var(--mm-red)]">{l}</TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="products"><ProductsTab /></TabsContent>
          <TabsContent value="orders"><OrdersTab /></TabsContent>
          <TabsContent value="settings"><SettingsTab /></TabsContent>
          <TabsContent value="messages"><MessagesTab /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
